export class StorefrontPolicyModel {
  reg?: string;
  acl?: string;
  dt?: string;
  sp?: Array<string>;
  ipr?: boolean;
  client?: string;
  clchuid?: string;
  pf?: string;
  prd?: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  un_channels?: string;
}
